import React from "react";
import LazyLoad from "react-lazyload";
import { Link } from "react-router-dom";
const Campuscare = () => {
  return (
    <>
      <div className="campuslogo">
        <Link to="https://canossa.campuscare.info/" target="_blank">
          <LazyLoad>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/Campulogo.png"
              className="img-fluid float-end campus"
              alt="Cannosa school"
            />
          </LazyLoad>
        </Link>
      </div>
    </>
  );
};

export default Campuscare;
